import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const MainContent = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(2),
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  [theme.breakpoints.down('md')]: {
    marginLeft: 0,
  },
  [theme.breakpoints.up('md')]: {
    marginLeft: 0, // Remover espaço extra lateral
    paddingLeft: theme.spacing(0.5), // Padding mínimo à esquerda
  },
}));